/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ChangeIncidentCustomerHeaders = zod.object({
  'idempotency-key': zod.string(),
  'x-csrf-token': zod.string(),
});

export type ChangeIncidentCustomerHeaders = zod.input<typeof ChangeIncidentCustomerHeaders>;
export type ChangeIncidentCustomerHeadersOutput = zod.output<typeof ChangeIncidentCustomerHeaders>;
